export default "__VITE_ASSET__ACjRJBo5__"